import "./home.css";

export const homePage = `<div class="home-container">
    <div class="home-section">
        <h1>Welcome to my mmorpg demo!</h1>

        <p>The purpose of this site is to demo my skills in web development.</p>
    </div>

    <div class="home-section">
        <h3>Play as Guest</h3>
        <button type="button" id="guest" class="home-button">
            Guest
        </button>
    </div>

    <div class="home-section">
        <h2>Sign in or play as Guest</h2>
        <form id="formData">
            <label for="email">Email</label>
            <input type="email" name="email" id="email">
            <label for="password">Password</label>
            <input type="password" name="password" id="password">
            <button type="button" id="submitAuth" class="home-button">Submit</button>
        </form>
    </div>
</div>`;
